<!--
 * @Description: 将数据通过k-form-item组件解析，生成控件
 * @Author: kcz
 * @Date: 2019-12-30 00:37:05
 * @LastEditTime: 2021-05-27 15:19:02
 * @LastEditors: kcz
 * @FilePath: \k-form-design\packages\KFormDesign\module\formNode.vue
 -->
<!--  -->
<!--
 * @Description: 修改事件绑定源,进入组件点击才进行编辑
 * 注释掉原来的双击事件
 * @dblclick="labelEdit"
-->
<template>
  <div
    class="drag-move-box"
    @click.stop="handleSelectItem"
    :class="{ active: record.key === selectItem.key, editModeClass: !editMode, cardStyle: true }"
  >
    <div class="form-item-box">
      <kFormItem @refreshOptions="refreshOptions" v-model="options.options" @handleSetSelectItem="handleSelectItem" @editModeStyle="editModeStyle" ref="formItem" :selectItem="selectItem" :formConfig="config" :record="record" />
      <formOption @refreshOptions="refreshOptions" :record="record" :selectItem="selectItem" :selectForm="selectForm" />
    </div>
    <div
      v-if="!hideModel"
      class="show-key-box"
      v-text="record.sequence + ' ' + record.label + (record.model ? '/' + record.model : '')"
    /> 
    <div
      v-if="!hideTypeModel"
      class="show-key-box"
      v-text="record.commponentTypeName"
    /> 
      <div
      class="relation"
      :class="record.key === selectItem.key ? 'active' : 'unactivated'"
      @click.stop="handleRelation"
    >
      <a-tooltip title="查看">
        <a-icon type="eye" :style="{ fontSize: '16px', color: '#323232' }"/>
      </a-tooltip>
    </div>
    <div
      v-if="enableCopy"
      class="copy"
      :class="record.key === selectItem.key ? 'active' : 'unactivated'"
      @click.stop="$emit('handleCopy')"
    >
      <a-tooltip title="复制">
        <a-icon type="copy" :style="{ fontSize: '16px', color: '#323232' }"/>
      </a-tooltip>
    </div>
    <div
      v-if="enableDelete"
      class="delete"
      :class="record.key === selectItem.key ? 'active' : 'unactivated'"
      @click.stop="$emit('handleDelete')"
    >
      <a-tooltip title="删除">
        <a-icon type="delete" :style="{ fontSize: '16px', color: '#323232' }"/>
      </a-tooltip>
    </div>
  </div>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 * description 通过json生成的单个表单节点
 */
import kFormItem from "../../KFormItem/index";
import formOption from "./formOption.vue";
export default {
  props: {
    record: {
      type: Object,
      required: true
    },
    selectItem: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      required: true
    },
    hideModel: {
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      type: Boolean,
      default: false
    },
    enableCopy: {
      type: Boolean,
      default: true
    },
    enableDelete: {
      type: Boolean,
      default: true
    },
    selectForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      editMode: false,
    }
  },
  computed: {
    // 获取当前表单的属性
    options() {
      return this.$props.selectItem.options || {};
    }
  },
  components: {
    kFormItem,
    formOption
  },
  methods:{
    labelEdit(e) {
      this.$refs.formItem.labelEdit();
    },
    handleSelectItem(e) {
      this.$emit('handleSelectItem', this.record)
    },
    editModeStyle(mode) {
      console.log(mode);
      this.editMode = mode;
    },
    refreshOptions() {
      this.$emit("refreshOptions");
    },
    
    handleRelation() {
      // 触发打开父子题关系设置弹窗事件
      if (!this.record) {
        return;
      }
      this.$emit('handleRelation', this.record);
    }
  }
};
</script>
<style scoped lang="less">
.editModeClass {
  /* 外层容器不拦截鼠标事件 */
  pointer-events: none;
}
.cardStyle {
  margin: 20px 0px;
}
.active {
  .show-key-box,.relation,.copy,.delete {
    pointer-events: auto !important;
  }
}
.drag-move-box {
  pointer-events: auto !important;
}

.relation, .copy, .delete {
  position: absolute;
  top: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  z-index: 999;
  display: none;
}

.drag-move-box:hover .copy, .drag-move-box:hover .delete {
  display: block;
}

.relation {
  right: 65px;
  top:12px;
}

.copy {
  right: 30px;
}

.delete {
  right: 0px;
}

.relation.active, .copy.active, .delete.active {
  display: block;
}

.relation.unactivated:hover, .copy.unactivated:hover, .delete.unactivated:hover {
  display: block;
}

.form-item-box::before {
  z-index: unset !important;
}
</style>